export const areas = [
  'M.I.D.C',
  'Bhaskar Market',
  'Fule Market',
  'Khote Nagar',
  'Transport Nagar',
  'Station Road',
  'Aasoda',
  'Ganesh colony',
  'Prem Nagar',
  'Ring Road',
  'Shivaji Nagar',
  'Shirsholi Road',
  'Mohadi Road',
  'Mamurabad Road',
  'Raisoni Nagar',
  'Adarsh Nagar'
];
